import { CSSProperties, forwardRef, ReactNode, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { indexData } from "../../forms";
import { resetFormState } from "../../store/actions/formAction";
import { selectTableItems, setPagination } from "../../store/actions";
import { FooterActions, HeaderActions, PageHeader, Pagination, TableItems, TableTabs } from "./components";
import { appSetSendingRequest, setConfirm } from "../../store/actions/appAction";

import { Container, IconButton, styled } from "@mui/material";

import "../../assets/styles/components/table.scss";
import "../../assets/styles/components/pagination.scss";
import { useLocation, useSearchParams } from "react-router-dom";
import ExportBotton, { ExportContainer, Item, StyledListItemIcon, StyledListItemText } from "./ExportBotton";
import DownloadIcon from "assets/icons/DownloadIcon";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import ScrollContainer from "react-indiana-drag-scroll";
import useKeyboardShortcuts from "helpers/useKeyboardShortcuts";
import { tableShortcuts } from "constants/keyboardConstant";
import { useReactToPrint } from "react-to-print";
import useDidUpdateEffect from "../../helpers/useDidUpdateEffect";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import { getDefaultCurrency } from "helpers";
import { formatPrice } from "helpers/dataFormat";
import { store } from "store/store";
import { apiGetWarehouses } from "api/warehouseApi";
const xlsx = require("xlsx");

export const TableContainer = styled("div")({
  backgroundColor: "white",
  borderRadius: "8px",
  // overflow: "hidden",
  height: "fit-content"
});
export const UpperContainer = styled("div")({
  height: "fit-content",
  width: "100%",
  display: "flex",
  justifyContent: "space-between"
});
export const UpperContainerLeft = styled("div")({
  height: "100%",
  display: "flex",
  alignItems: "center",
  paddingLeft: "12px",
  justifyContent: "space-between"
});

interface Props {
  type?: string;
  tabs?: any;
  data?: any;
  pagination?: boolean;
  MidComponent?: any;
  middleComp?: ReactNode;
  printComp?: ReactNode;
  titleSection?: ReactNode;
  withDateFilter?: boolean;
  disableDateFilter?: boolean;
  hideTab?: boolean

  onTabChange?: (options: any) => void;
  onSearch?: (options: any) => void;
  style?: CSSProperties;
  ActionSection?: ReactNode;
  fetchOnPaginationChange?: boolean;
  getParamsBeforeFetch?: (params: any) => { params: any }
  disablePagination?: boolean;
  sumAmountInfo?: { name: string, isCurrency?: boolean }[]
}

export default function Table(props: Props) {
  const {
    type,
    pagination,
    middleComp,
    sumAmountInfo,
    MidComponent,
    withDateFilter,
    getParamsBeforeFetch,
    hideTab,
    fetchOnPaginationChange = true
  } = props;
  const { onTabChange, onSearch, style, printComp, titleSection, disableDateFilter, disablePagination } =
    props;

  const tabs: any[] = props.tabs || indexData(type) || [];
  const dispatch = useDispatch();
  const location = window.location;
  const [searchParams] = useSearchParams();
  const [personId, setPersonId] = useState<string | null>(null)

  const loc = useLocation();
  const state: any = loc.state;
  const renderTabType = state && state.type ? state.type : undefined;
  const store = useSelector((state: any) => state);
  const { currencies } = useSelector((state: any) => state).currencyReducer;
  const business = useSelector((state: any) => state).businessReducer.business;

  const currency = getDefaultCurrency(business.business.default_currency_id, currencies);
  const token = store.businessReducer.business?.token;
  const dataTable = props.data || store.dataTableReducer;
  const paginationState = store.paginationReducer;
  const sendingRequest = store.appReducer.sendingRequest;
  const defaultTab: any = tabs.find((t) => {
    if (t.defaultTab !== undefined) return t.defaultTab === true;
    return t.key === (renderTabType ?? tabs[0].key);
  });
  useEffect(() => {
    setActiveTab(defaultTab)

    return () => {

    }
  }, [tabs])

  const [activeTab, setActiveTab] = useState(defaultTab);
  const pageRef = useRef(null);
  const selectedItems = store.selectBoxTableValueReducer.selectedIds[activeTab?.key] ?? [];

  const searchQuery = paginationState.search;
  const sortQuery = paginationState.sort;

  const setSortQuery = (sort: any) => {
    dispatch(setPagination(Object.assign(paginationState, { sort })));
  };

  const setSearchQuery = (search: any) => {
    if (search) {
      const filters = paginationState?.filters || []
      const index = filters.findIndex((x: any) => x.column === search.column)
      if (index > -1) {
        filters.splice(index, 1)
      }
      if (search.primarySearch != "" && search.primarySearch && search.primarySearch != null)
        filters.push(search)
      return dispatch(setPagination(Object.assign(paginationState, { search })));
      dispatch(setPagination(Object.assign(paginationState, { search, filters })));
    }

    //  dispatch(setPagination(Object.assign(paginationState, { search })));


    // if (search === null) {
    //   return dispatch(setPagination(Object.assign(paginationState, { search: [] })));
    // }
    // //if (search.columnType) {
    // const filters = Array.isArray(paginationState?.search) ? paginationState?.search : []
    // //  const index = filters.findIndex((x: any) => x.column === search.column)
    // // if (index > -1) {
    // //   filters.splice(index, 1)
    // // }
    // //if (search.primarySearch != "")
    // filters.push(search)
    // return dispatch(setPagination(Object.assign(paginationState, { search: filters })));

    //}

  };

  useEffect(() => {
    dispatch(resetFormState());
    dispatch(appSetSendingRequest(false));
  }, []);

  useEffect(() => {
    if (onTabChange) {
      onTabChange({ activeTab, tabs, paginationState });
      return;
    }
    dispatch(setPagination({ ...paginationState, page: 1, search: {}, sort: {}, filters: [] }));
    setSelectedItems([]);
  }, [activeTab]);

  useDidUpdateEffect(() => {
    fetchOnPaginationChange && fetchItems();
  }, [paginationState]);

  const fetchItems = (srt?: any, srch?: any) => {
    const fetchlessItems: string[] = [];
    if (activeTab && !fetchlessItems.includes(activeTab.key)) {
      const Fetch = activeTab.actions.fetch;

      const sort = srt ?? sortQuery;
      const search = srch ?? searchQuery;
      const { params } = getParamsBeforeFetch ? getParamsBeforeFetch({}) : { params: {} }
      // if (activeTab.isCheque) {
      //   Fetch && dispatch(Fetch(paginationState, token, activeTab.key, activeTab.type, sort, search));
      // } else {
      let id = activeTab.id;
      if (activeTab.queryParamKey) {
        const searchParams = new URLSearchParams(document.location.search);
        id = parseInt(searchParams.get(activeTab.queryParamKey) || "0");
      }
      Fetch &&
        dispatch(
          Fetch({
            pagination: paginationState,
            token,
            options: params,
            key: activeTab.key,
            filters: paginationState.filters,
            type: activeTab.type,
            id,
            sort,
            search,
            location,
            activeTab
          })
        );
    }
  }

  const deleteItems = (selectedItems: any, item?: any) => {
    const confirmTitle = selectedItems.length > 1 ? activeTab.pluralLabel : activeTab.label;

    const action: any = () =>
      dispatch(activeTab?.actions?.delete(selectedItems, token, activeTab, fetchItems, !Array.isArray(item) ? [item] : item));
    dispatch(setConfirm(confirmTitle, action));
  };

  const setSelectedItems = (selectedIds: any) => {
    if (activeTab.key) {
      dispatch(selectTableItems(selectedIds, activeTab.key));

    }
  };

  const selectItem = (id: any) => {
    let tempSelectedItems = selectedItems;
    if (tempSelectedItems.includes(id)) {
      tempSelectedItems.splice(tempSelectedItems.indexOf(id), 1);
    } else {
      tempSelectedItems.push(id);
    }
    setSelectedItems(tempSelectedItems);
  };

  const selectAllItems = () => {
    if (selectedItems.length === dataTable.items.length) {
      setSelectedItems([]);
    } else {
      let tempSelectedItems: any = [];
      dataTable.items.map((item: any) => {
        tempSelectedItems.push(item.id);
      });
      setSelectedItems(tempSelectedItems);
    }
  };
  const getSumValue = (args: { colName: string }) => {
    const { colName } = args
    const isCurrency = sumAmountInfo?.find(x => x.name === colName)?.isCurrency

    const sumAmount = dataTable.sumAmount
    if (sumAmount) {
      const val = sumAmount.find((y: any) => y[colName]);
      if (val) return `${formatPrice(val[colName])} ${isCurrency ? currency.fa_title : ""}`
    }
    return ""



  }
  const downloadTable = (type: any) => {
    if (type === "excel") {
      const data: any = [];
      dataTable.items.map((item: any) => {
        const row = {};
        activeTab?.tableColumns.map((title: any) => {
          (row as any)[title["name"]] = title.getValue ? title.getValue(item) : item[title["key"]];
        });
        data.push(row);
      });
      if (sumAmountInfo && sumAmountInfo?.length) {
        const row = {}
        activeTab?.tableColumns.map((title: any) => {
          (row as any)[title["name"]] = getSumValue({ colName: title.key });
        });
        data.push(row)
      }
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, activeTab.pluralLabel ?? activeTab.label);
      //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      xlsx.writeFile(workbook, `${activeTab.key.charAt(0).toUpperCase() + activeTab.key.slice(1)}.xlsx`);
    }
  };

  const downloadCategoryExcel = () => {
    let exportCategories = activeTab.actions.excel.exportCategory;
    exportCategories &&
      dispatch(
        exportCategories(token)
      );
  };



  const activeTabKey = tabs.findIndex((item: any) => item === activeTab);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  // handle what happens on key press
  const handleKey = (val: { key: string; value: string; label: string; route?: string }) => {
    // Perform save action

    const setPage = (page: any) => {
      dispatch(setPagination({ ...paginationState, page: page }));
    };

    switch (val.key) {
      case "keyboardShortcutSelectAll":
        selectAllItems();
        break;
      case "keyboardShortcutFirstPage":
        setPage(1);
        break;
      case "keyboardShortcutLastPage":
        setPage(dataTable.paginate.lastPage);
        break;
      case "keyboardShortcutPreviousPage":
        dataTable.paginate.hasPreviousPage && setPage(dataTable.paginate.previousPage);
        break;
      case "keyboardShortcutNextPage":
        dataTable.paginate.hasNextPage && setPage(dataTable.paginate.nextPage);
        break;
      case "keyboardShortcutDownloadPdf":
        // handlePrint();
        break;
      case "keyboardShortcutDownloadExcel":
        downloadTable("excel");
        break;
      default:
        break;
    }
  };
  useKeyboardShortcuts(tableShortcuts, handleKey);
  //== keyboard shortcut

  const handlePrint = useReactToPrint({
    content: () => pageRef.current
  });

  // @ts-ignore
  return (
    activeTab && (
      <Container style={{ ...style }} maxWidth="xl" >
        <div className="warp-table" style={{ ...style }}>
          <div className="header-table">
            <PageHeader activeTab={activeTab} />
            <HeaderActions
              fetchItems={fetchItems}
              actions={activeTab.actions}
              activeTab={activeTab}
              selectedItems={selectedItems}
            />
          </div>
          <div>
            {activeTab.key === "product" &&
              (
                <ExportContainer>
                  <Item disableRipple onClick={() => downloadCategoryExcel()}>
                    <StyledListItemIcon>
                      <SnippetFolderIcon color="success" />
                    </StyledListItemIcon>
                    <StyledListItemText> دانلود اکسل دسته بندی ها</StyledListItemText>
                  </Item>
                </ExportContainer>
              )
            }
          </div>

          {!activeTab?.actions?.disableMidComponent && MidComponent && <MidComponent activeTab={activeTab} />}
          {!activeTab?.actions?.disableMidComponent && middleComp}
          {titleSection}

          {!disablePagination && (
            <Pagination
              key={2}
              onlyPagination
              activeTab={activeTab}
              // active={selectedItems.length === 0}
              active={true}
              paginateData={dataTable.paginate}
              selectedItems={selectedItems}
              fetchItems={fetchItems}
            />
          )}
          <TableContainer>
            <UpperContainer className="overflow-x-auto md:overflow-hidden">
              {tabs && !hideTab && tabs.length > 1 ? (
                <TableTabs
                  tabs={tabs}
                  activeTab={activeTab}
                  activeTabKey={activeTabKey}
                  setActiveTab={setActiveTab}
                />
              ) : (
                <div></div>
              )}
              <UpperContainerLeft>
                {!disablePagination && (
                  <Pagination
                    key={1}
                    activeTab={activeTab}
                    // active={selectedItems.length === 0}
                    active={true}
                    dataTable={dataTable}
                    selectedItems={selectedItems}
                    fetchItems={fetchItems}
                    onlySelect
                  />
                )}
                <IconButton
                  sx={{
                    width: "32px",
                    height: "32px",
                    border: "1px solid #1062D0",
                    borderRadius: "6px"
                  }}
                  onClick={handleClick}
                >
                  <DownloadIcon primary={true} />
                </IconButton>
                <ExportBotton
                  ref={pageRef}
                  downloadTable={downloadTable}
                  key={activeTab?.key}
                  handleClose={handleClose}
                  anchorEl={anchorEl}
                />
              </UpperContainerLeft>
            </UpperContainer>
            <TableBody
              disableSearch={activeTab?.disableSearch}
              pagination={pagination}
              activeTab={activeTab}
              dataTable={dataTable}
              selectAllItems={selectAllItems}
              selectedItems={selectedItems}
              selectItem={selectItem}
              deleteItem={(id: any, item: any) => deleteItems([id], item)}
              ref={pageRef}
              onSearch={onSearch}
              printComp={printComp}
              fetchItems={fetchItems}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              sortQuery={sortQuery}
              setSortQuery={setSortQuery}
              type={type}
              sumAmountInfo={sumAmountInfo}
              MidComponent={MidComponent}
            />
          </TableContainer>
          <FooterActions
            activeTab={activeTab}
            rows={dataTable.items}
            selectedItems={selectedItems}
            deleteItems={() => deleteItems(selectedItems, dataTable.items.filter((x: any) => selectedItems.includes(x.id)))}
            ActionSection={props.ActionSection}
          />
        </div>
      </Container >
    )
  );
}

const getColumns = (columns: any, key: any, allColumns: any) => {
  try {
    const column = columns.find((item: any) => item.key === key);
    const renderColumnKeys = column
      ? column.columns.map((c: any) => c.key)
      : allColumns.columns.map((c: any) => c.key);
    const renderColumns = allColumns.filter((a: any) => renderColumnKeys.includes(a.key));

    if (renderColumns.length === 0) return null;
    return renderColumns;
  } catch {
    return null;
  }
};
const orderColumns = (tableOrder: any, columns: any, key: any) => {
  try {
    const order = tableOrder.find((item: any) => item.key === key);
    const ordered: any = [];
    order.columns.forEach((element: any) => {
      const foundedIndex = columns.findIndex((el: any) => el.key === element.key);
      if (foundedIndex !== -1) ordered.push(columns[foundedIndex]);
    });
    if (ordered.length === 0) return null;
    return ordered;
  } catch {
    return null;
  }
};

interface TableBodyProps {
  activeTab: any;
  dataTable: any;
  selectedItems: any[];
  selectAllItems: any;
  selectItem: any;
  deleteItem: any;
  disableSearch: any;
  pagination: any;
  onSearch?: any;
  printComp?: ReactNode;
  fetchItems?: any;
  sortQuery: any;
  setSortQuery: any;
  searchQuery: any;
  setSearchQuery: any;
  MidComponent?: any;
  type?: string;
  sumAmountInfo?: { name: string, isCurrency?: boolean }[]
}

export const TableBody = forwardRef(
  (
    {
      activeTab,
      dataTable,
      selectedItems,
      selectAllItems,
      selectItem,
      deleteItem,
      onSearch,
      printComp,
      fetchItems,
      sortQuery,
      setSortQuery,
      searchQuery,
      setSearchQuery,
      MidComponent,
      sumAmountInfo,
      type
    }: TableBodyProps,
    ref
  ) => {
    const [warehouses, setWarehouses] = useState<any[]>([])
    const { dispatch } = store
    const getWarehouses = async () => {
      await dispatch(apiGetWarehouses(true, (res: any, warehouse: any[]) => {
        setWarehouses(warehouse)
      }))
    }
    useEffect(() => {
      if (activeTab.dynamicColumns === "warehouses" && warehouses.length === 0) {
        getWarehouses()
      }

      return () => {

      }
    }, [activeTab.dynamicColumns])

    const searchItems = (sort: any, search: any) => {
      // dispatch(setPagination({ sort, search }));

      if (onSearch) {
        onSearch({ sort: sort || sortQuery, search: search || searchQuery });
        return;
      } else {
        fetchItems(sort || sortQuery, search || searchQuery);
      }
    };

    const renderColumns = (columns?: any) => {
      if (activeTab.dynamicColumns) {
        const tableColumns: { name: any; key: string; getValue: (item: any) => any }[] = [];
        const data = activeTab.dynamicColumns === "warehouses" ? warehouses : [];
        const appReducer: any = store.getState().appReducer
        //const cols = appReducer.tableColumns.find((x: any) => x.key === "inventorySupplyByProduct")
        if (columns) {
          columns.map((t: any) => tableColumns.push(t));
        } else {
          activeTab.tableColumns.map((t: any) => tableColumns.push(t));
        }
        data.forEach((d: any) => {

          // if (cols) {
          //   if (cols?.columns.findIndex((x: any) => x.key === `dynamic-${d.id}`) > -1) {

          //     let tempItem = {
          //       name: d.title,
          //       key: `dynamic-${d.id}`,
          //       getValue: (item: any) => {
          //         return item.supply?.find((s: any) => s.warehouseId === d.id)?.quantity ?? 0;
          //       }
          //     };
          //     tableColumns.push(tempItem);

          //   }
          // } else {
          let tempItem = {
            name: d.title,
            key: `dynamic-${d.id}`,
            getValue: (item: any) => {
              return item.supply?.find((s: any) => s.warehouseId === d.id)?.quantity ?? 0;
            }
          };
          tableColumns.push(tempItem);
        }
          // }

          // }
        );

        return tableColumns;
      }

      return columns ?? activeTab.tableColumns;
    };

    const setHeaderInPdf = () => {
      if (type) {
        switch (type) {
          case "salesByFactor":
          case "buysByFactor":
          case "buyByProducts":
          case "sellByProducts":
            return <MidComponent />;
        }
      }
    };

    const tableColumns = useSelector((state: any) => state).appReducer.tableColumns || [];
    const tableOrders = useSelector((state: any) => state).appReducer.tableOrders || [];

    const columns =
      getColumns(tableColumns, activeTab?.key, activeTab?.tableColumns) || activeTab?.tableColumns;
    const orderedColumns = orderColumns(tableOrders, columns, activeTab?.key) || columns;
    return (
      <div
        ref={ref as any}
        style={{
          position: "relative"
          // marginBottom: `${pagination ? '50px' : '0px'}`
        }}
      >

        <div className="body-table" style={{ direction: "rtl" }}>
          <ScrollContainer className="scroll-container">
            <TableItems
              sumAmountInfo={sumAmountInfo}
              activeTab={activeTab}
              titles={renderColumns(orderedColumns)}
              items={dataTable.items}
              selectAllItems={selectAllItems}
              selectedItems={selectedItems}
              selectItem={selectItem}
              deleteItem={deleteItem}
              actions={activeTab.actions}
              sortQuery={sortQuery}
              setSortQuery={setSortQuery}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              searchItems={searchItems}
              allTitles={renderColumns()}
              tableItemsLength={dataTable.items?.length}
              selectedItemsLength={selectedItems.length}
            />
          </ScrollContainer>
        </div>
        {/* <div className="d-none">
          <div className="body-table" style={{ direction: "rtl" }} ref={ref as any}>
            {setHeaderInPdf()}
            {printComp}
            <TableItems
              activeTab={activeTab}
              titles={renderColumns(orderedColumns)}
              items={dataTable.items}
              selectAllItems={selectAllItems}
              selectedItems={selectedItems}
              selectItem={selectItem}
              deleteItem={deleteItem}
              actions={activeTab.actions}
              sortQuery={sortQuery}
              setSortQuery={setSortQuery}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              searchItems={searchItems}
              allTitles={renderColumns()}
              tableItemsLength={dataTable.items?.length}
              selectedItemsLength={selectedItems.length}
            />
          </div>
        </div> */}

      </div>
    );
  }
);
